<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :span="5">
            <a-form-item label="项目名称">
              <a-select
                showSearch
                optionFilterProp="children"
                placeholder="请输入项目"
                @change="getData"
                @filterOption="onSearchMod"
                v-model="projectId"
              >
                <a-select-option
                  v-for="d in proDatas"
                  :key="d.id"
                >{{ d.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div>
      <realtime-list v-for="m in dataSource" :title="m.title">
        <template>
          <realtime-data v-for="d in m.data" :title="d.传感器" :dt="d.数据时间" :clz="d.测量值" :wd="d.温度" :pcz="d.变化值" ></realtime-data>
          <!-- 
          <realtime-data :title="data.title"></realtime-data>
          <realtime-data :title="data.title"></realtime-data>
          <realtime-data :title="data.title"></realtime-data>
          -->
        </template>
      </realtime-list>
    </div>
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage'
import RealtimeList from './components/RealtimeList.vue'
import RealtimeData from './components/RealtimeData.vue'
import moment from 'moment'

export default {
  name: 'TwoDimension',
  components: {
    RealtimeList,
    RealtimeData
  },
  data () {
    return {
      data: {
        title: 'WSD-202001'
      },
      queryParam: { ds: '0', beginTime: moment(new Date()).add(-3, 'days'),pageNo:1, pageSize: 600 },
      proDatas: [],
      projectId: '',
      dataSource: [],
      url: {
        getRealTimeData: '/device/data/listDevice',
        getProList: "/project/project/listAll",
      },
    }
  },
  created() {
    this.getProDatas();
    
  },
  methods: {
    getProDatas () {
      getAction(this.url.getProList, {}).then((res) => {
        if (res.success) {
          this.proDatas = res.result;
          if(this.proDatas.length >0) {
            this.projectId = this.proDatas[0].id;
            this.getData(this.proDatas[0].id);
          }
        }
      })
    },
    getData(val) {
      this.queryParam.projectId = val;
      getAction(this.url.getRealTimeData, this.queryParam).then(res => {
        //console.log(res.result.records);
        let dtMap = new Map();
        let sbMap = new Map();
        this.dataSource = [];
        for(var i=0;i<res.result.records.length;i++){
          let value = res.result.records[i];
          value.数据时间 = value.数据时间.substring(0, 19);
          
          if(sbMap.has(value.传感器标识)){
            continue;
          }else{
            sbMap.set(value.传感器标识,value);
          }
          
          if(dtMap.has(value.模块名称)){
            dtMap.get(value.模块名称).data.push(value);
          }else{
            let tempData = [];
            tempData.push(value);
            let obj = {title:'', data:tempData};
            obj.title = value.模块名称;
            this.dataSource.push(obj);
            //console.log(value.传感器标识 + '==' + value.模块名称);
            dtMap.set(value.模块名称, obj);
          }
        };

        //this.dataSource = dtMap.values();
        console.log(this.dataSource);
      });
    },
  },
}
</script>

<style lang='less' scoped>
</style>
